import React from "react";
import "../../Informations/Information.css";
import nillbenifits from "../../../Assets/Picture1.png";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
const AddressingNilInequality = () => {
  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="business-price-numbs">
          <div className="nill-img-text-hone">
            <div className="nill-img-aboutus">
              <img src={nillbenifits} alt="" />
            </div>
            <div>
              <h2 className="htwo-heading-aboutus">
                Addressing NIL Inequality
              </h2>
              <p className="text-aboutus">
                Inequality in NIL (Name, Image, Likeness) opportunities between
                athletes from larger programs and those from smaller schools is
                a growing challenge in collegiate athletics. While top-tier
                athletes at major programs often gain significant visibility and
                media attention, athletes from smaller schools may find it
                harder to attract sponsorships or brand partnerships despite
                their talent and dedication.
              </p>
              <p className="text-aboutus">
                This inequality can create frustration and impact morale,
                especially when athletes feel their abilities and achievements
                are not fully recognized. It can also widen the gap between
                major programs and smaller schools, making recruiting and talent
                retention more difficult for less-visible programs.
              </p>
            </div>
          </div>
          <div className="program-benefits-aboutus">
            <p className="text-aboutus">
              {/* <span style={{ fontWeight: "600" }}>NIL-Collab platform</span>  */}
              NIL-Collab is designed to support all athletes, regardless of
              program size, by providing a fair and transparent platform to
              connect with fans, brands, and supporters. This is especially
              valuable for athletes from smaller schools who may not have the
              same exposure or resources as those at larger programs.
              Transparency ensures that all engagements are clear, trustworthy,
              and equitable.
            </p>
            <p className="text-aboutus">
              By helping athletes showcase their skills, grow their social
              presence, and access opportunities that align with their personal
              and professional goals, NIL-Collab empowers student-athletes to
              excel both on and off the field. As NIL continues to evolve,
              NIL-Collab supports schools and athletes in managing opportunities
              fairly, building trust, and fostering long-term success in college
              athletics.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default AddressingNilInequality;

// import React from 'react'
// import "../../Informations/Information.css"
// import nillbenifits from "../../../Assets/Picture1.png"
// import Header from '../../Header/Header'
// import Footer from '../../Footer/Footer'
// const AddressingNilInequality = () => {
//     return (
//         <>
//             <Header />
//             <div className='page-main-container-aboutus'>
//                 <div className='business-price-numbs'>
//                     <div className='nill-img-text-hone'>
//                         <div className='nill-img-aboutus'>
//                             <img src={nillbenifits} alt="" />
//                         </div>
//                         <div>
//                             <h2 className='htwo-heading-aboutus' >The Benefits of NIL-Collab</h2>
//                             <p className='text-aboutus'>
//                                 The inequality in NIL (Name, Image, Likeness) deals between athletes from larger programs and those from smaller schools is a growing issue in collegiate athletics. While top-tier athletes at major programs often land big endorsement deals due to their visibility and media presence, athletes from smaller schools may find it much harder to attract significant sponsorships or brand partnerships, despite their talent and hard work.</p>
//                             <p className='text-aboutus'>
//                                 Any inequality creates a sense of dissatisfaction, as athletes may feel that their worth isn't being fully recognized or rewarded. Moreover, it could lead to morale issues within teams, especially if players feel that those at bigger schools have an unfair advantage. Some argue that this could potentially widen the gap between major athletic programs and smaller ones, making it harder for the latter to compete in both recruiting and talent retention.</p>
//                         </div>
//                     </div>
//                     <div className='program-benefits-aboutus'>

//                         <p className='text-aboutus'><span style={{ fontWeight: "600" }}>NIL-Collab platform</span> is designed to support all athletes, regardless of the size of their programs, by providing a fair and transparent way to receive contributions. This will be beneficial for many athletes, especially those from smaller programs that might not have the same level of exposure or resources as larger ones. The transparency aspect is important, too, as it ensures contributors can trust where their contributions are going. NIL-Collab works with securing contributions from collectives and individual contributions from local businesses, alumni, and fans.</p>
//                         <p className='text-aboutus'>These contributions help ensure that student-athletes can excel in both their academic and athletic endeavors, setting them up for future success and contributing to their overall growth. As NIL continues to evolve, NIL-Collab will assist schools in finding ways to manage and improve opportunities will be key to ensuring fairness and long-term sustainability in college athletics.</p>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }
// export default AddressingNilInequality
